import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { filter, takeUntil } from 'rxjs/operators';
import {  Subject, } from 'rxjs';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { AuthenticationService } from '@services/authentication.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {

    loading = false;
    accounts = [];
    accessToken: string = '';
    selectedAccount: any = null;

    entraIdLogged = false;

    private readonly _destroying$ = new Subject<void>();

    constructor(
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private authService: MsalService,
        private loginService: AuthenticationService,
        private msalBroadcastService: MsalBroadcastService,
        private renderer: Renderer2
    ) {
    }

    ngOnInit() {
        this.renderer.addClass(document.body, 'login-page');

        this.entraIdLogged = this.authService.instance.getActiveAccount() != null;

        if (this.entraIdLogged) {
            this.loadAccounts();
        }

        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                takeUntil(this._destroying$)
            )
            .subscribe(() => {
                // this.setLoginDisplay();
                this.checkAndSetActiveAccount();
            })
    }

    checkAndSetActiveAccount(){
        /**
         * If no active account set but there are accounts signed in, sets first account to active account
         * To use active account set here, subscribe to inProgress$ first in your component
         * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
         */
        let activeAccount = this.authService.instance.getActiveAccount();

        if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
            let accounts = this.authService.instance.getAllAccounts();
            this.authService.instance.setActiveAccount(accounts[0]);
            this.entraIdLogged = true;
            this.loadAccounts();
        }
    }

    loginRedirect() {
        if (this.msalGuardConfig.authRequest){
            this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
        } else {
            this.authService.loginRedirect();
        }
    }

    onAccountSelect(account: any) {
        this.selectedAccount = account;
        console.log('Account selezionato:', account);

        this.loading = true;
        this.loginService.loginWithEntraId(account.id, this.accessToken)
            .subscribe((res) => {
                this.loading = false;
                console.log('Login effettuato con successo:', res);
                // Gestisci la risposta del login, ad esempio reindirizza l'utente
                window.location.href = '/dashboard'; // Esempio di reindirizzamento
            }, (error) => {
                console.error('Errore durante il login:', error);
                // Gestisci l'errore di login
            });
    }

    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'login-page');
        this._destroying$.next(null);
        this._destroying$.complete();
    }

    private loadAccounts() {
        this.loading = true;
        this.authService.instance.acquireTokenSilent({
            scopes: ["user.read"]
        }).then((response: AuthenticationResult) => {
            this.accessToken = response.accessToken;

            this.loginService.loginAccounts(this.accessToken)
                .subscribe((res) => {
                    this.accounts = res;
                    this.loading = false;
                });
        });
    }
}
